import gql from 'graphql-tag';

export const setSubmissionVisitorApproval = gql(/* GraphQL */ `
  mutation SetSubmissionVisitorApproval($input: SetSubmissionVisitorApprovalInput!) {
    setSubmissionVisitorApproval(input: $input) {
      id
    }
  }
`);

